import { ActivityLogs } from './ActivityLogs'
import { ApiCredentials } from './ApiCredentials'

export function Settings() {
  return (
    <div className="space-y-8">
      <div>
        <h2 className="text-2xl font-semibold">Settings</h2>
        <p className="text-sm text-slate-400 mt-1">Manage API credentials and view activity logs</p>
      </div>

      <ApiCredentials />

      <div className="border-t border-slate-700 pt-8">
        <ActivityLogs />
      </div>
    </div>
  )
}
